// extracted by mini-css-extract-plugin
export default {"container":"check-box_container__DPsYz"};